import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { APISD } from "../../../../../config/apisd";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleList, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";


import { PulseLoader } from "react-spinners";

export default function Leger() {
  document.title = "Leger";

  const token = localStorage.getItem("token");
  const storageBranchGroping =
    localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  const location = useLocation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);
  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);
  const [loadingTypeLeger, setLoadingTypeLeger] =
    useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [loadingFinalValue, setLoadingFinalValue] =
    useState(false);
  const [finalValueHeaders, setFinalValueHeaders] =
    useState([]);
  const [finalValueStudents, setFinalValueStudents] =
    useState([]);
  const [searchFinalValue, setSearchFinalValue] =
    useState("");
  const [loadingRawValue, setLoadingRawValue] = useState(false);
  const [downloadingRawValue, setDownloadingRawValue] = useState(false);
  const [loadingMatpel, setLoadingMatpel] = useState(false);
  const [rawValueHeaders, setRawValueHeaders] = useState([]);
  const [rawValueStudents, setRawValueStudents] = useState([]);
  const [rawValueWeights, setRawValueWeights] = useState({});
  const [getDataMatpel, setGetDataMatpel] = useState([]);
  const [selectedMatpel, setSelectedMatpel] = useState("");
  const [searchRawValue, setSearchRawValue] = useState("");
  const [loadingSpecialValue, setLoadingSpecialValue] = useState(false);
  const [loadingSpecialMatpel, setLoadingSpecialMatpel] = useState(false);
  const [loadingTypeActivities, setLoadingTypeActivities] = useState(false);
  const [loadingSubActivities, setLoadingSubActivities] = useState(false);
  const [specialMatpels, setSpecialMatpels] = useState([]);
  const [typeActivities, setTypeActivities] = useState([]);
  const [subActivities, setSubActivities] = useState([]);
  const [selectedSpecialMatpel, setSelectedSpecialMatpel] = useState("");
  const [selectedTypeActivity, setSelectedTypeActivity] = useState("");
  const [specialValueHeaders, setSpecialValueHeaders] = useState([]);
  const [specialValueStudents, setSpecialValueStudents] = useState([]);
  const [searchSpecialValue, setSearchSpecialValue] = useState("");

  const [getDataSemesterMap, setGetDataSemesterMap] =
    useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);
  const [getDataTypeLeger, setGetDataTypeLeger] =
    useState([]);

  const [selectedTypeLeger, setSelectedTypeLeger] =
    useState("");

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);
  const initKelasDone = useRef(false);
  const loadedTabDataKey = useRef("");
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });

  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
    ysb_kelas_id: "",
  });

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const academicYears = useMemo(() => {
    return Array.from(
      new Set(
        getDataSemesterMap
          .map((semester) => semester?.name_year)
          .filter(Boolean)
      )
    );
  }, [getDataSemesterMap]);

  const semestersInSelectedYear = useMemo(() => {
    return getDataSemesterMap
      .filter(
        (semester) => semester?.name_year === namaTA
      )
      .sort(
        (a, b) =>
          Number(a?.semester || 0) -
          Number(b?.semester || 0)
      );
  }, [getDataSemesterMap, namaTA]);

  const selectedSemesterData = useMemo(
    () =>
      getDataSemesterMap.find(
        (semester) =>
          String(semester?.id) ===
          String(form2.ysb_semester_id)
      ),
    [getDataSemesterMap, form2.ysb_semester_id]
  );

  const selectedTypeLegerData = useMemo(
    () =>
      getDataTypeLeger.find(
        (item) =>
          String(item?.id) ===
          String(selectedTypeLeger)
      ),
    [getDataTypeLeger, selectedTypeLeger]
  );

  const isFinalValueTab = useMemo(() => {
    const name = String(
      selectedTypeLegerData?.name_type || ""
    ).toLowerCase();

    return (
      name.includes("nilai akhir semester") ||
      name.includes("nilai akhir")
    );
  }, [selectedTypeLegerData]);

  const isRawValueTab = useMemo(() => {
    const name = String(selectedTypeLegerData?.name_type || "").toLowerCase();
    return name.includes("nilai mentah") || name.includes("raw value");
  }, [selectedTypeLegerData]);

  const isSpecialValueTab = useMemo(() => {
    const name = String(selectedTypeLegerData?.name_type || "").toLowerCase();
    return name.includes("nilai khusus") || name.includes("special value");
  }, [selectedTypeLegerData]);

  const filteredFinalValueStudents = useMemo(() => {
    const keyword = searchFinalValue
      .trim()
      .toLowerCase();

    if (!keyword) {
      return finalValueStudents;
    }

    return finalValueStudents.filter((student) =>
      String(student?.nama_lengkap || "")
        .toLowerCase()
        .includes(keyword)
    );
  }, [finalValueStudents, searchFinalValue]);

  const filteredRawValueStudents = useMemo(() => {
    const keyword = searchRawValue.trim().toLowerCase();
    if (!keyword) return rawValueStudents;
    return rawValueStudents.filter((student) =>
      String(student?.nama_lengkap || "").toLowerCase().includes(keyword)
    );
  }, [rawValueStudents, searchRawValue]);

  const filteredSpecialValueStudents = useMemo(() => {
    const keyword = searchSpecialValue.trim().toLowerCase();
    if (!keyword) return specialValueStudents;
    return specialValueStudents.filter((student) =>
      String(student?.nama_lengkap || "").toLowerCase().includes(keyword)
    );
  }, [specialValueStudents, searchSpecialValue]);

  useEffect(() => {
    return () => {
      isMounted.current = false;

      abortControllers.current.forEach((controller) => {
        controller.abort();
      });
    };
  }, []);

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems =
      JSON.parse(
        localStorage.getItem("role_permission")
      ) || [];

    if (
      level === "developer" ||
      level === "superadmin"
    ) {
      setPermission({
        create: 1,
        read: 1,
        update: 1,
        delete: 1,
      });

      return;
    }

    const foundPermission = storageItems.find(
      (item) => item.menu?.url === location.pathname
    );

    if (!foundPermission) {
      navigate("/dashboard");
      return;
    }

    setPermission({
      create: foundPermission.create,
      read: foundPermission.read,
      update: foundPermission.update,
      delete: foundPermission.delete,
    });
  }, [location.pathname, navigate]);

  const sortSchools = useCallback((schools) => {
    const schoolOrder = ["SD", "SMP", "SMA"];

    return [...schools].sort((a, b) => {
      const nameA = String(
        a?.school_name || ""
      ).toUpperCase();

      const nameB = String(
        b?.school_name || ""
      ).toUpperCase();

      let indexA = schoolOrder.findIndex((item) =>
        nameA.includes(item)
      );

      let indexB = schoolOrder.findIndex((item) =>
        nameB.includes(item)
      );

      if (indexA === -1) {
        indexA = schoolOrder.length;
      }

      if (indexB === -1) {
        indexB = schoolOrder.length;
      }

      if (indexA !== indexB) {
        return indexA - indexB;
      }

      return nameA.localeCompare(nameB, "id", {
        numeric: true,
        sensitivity: "base",
      });
    });
  }, []);

  const sortLevels = useCallback((levels) => {
    return [...levels].sort((a, b) =>
      String(a?.name_level || "").localeCompare(
        String(b?.name_level || ""),
        "id",
        {
          numeric: true,
          sensitivity: "base",
        }
      )
    );
  }, []);

  const sortKelas = useCallback((classes) => {
    return [...classes].sort((a, b) =>
      String(a?.name_kelas || "").localeCompare(
        String(b?.name_kelas || ""),
        "id",
        {
          numeric: true,
          sensitivity: "base",
        }
      )
    );
  }, []);

  const removeBasementBekasi = useCallback(
    (schools, branchId) => {
      if (branchId === "BKS") {
        return schools.filter(
          (school) =>
            school?.school_code !==
            "BASEMENT_BEKASI"
        );
      }

      return schools;
    },
    []
  );

  const fetchInit = useCallback(async () => {
    setLoading(true);

    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [
        branchResponse,
        semesterResponse,
      ] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=1&limit=1000&ascending=1&search=&branch=${storageBranchGroping}&level=${storageLevel}`,
          {
            ...fetchParams,
            signal: controller.signal,
          }
        ),

        APIMS.get(
          "/api/access/semesters?page=1&limit=1000&ascending=0&search=",
          {
            ...fetchParams,
            signal: controller.signal,
          }
        ),
      ]);

      if (!isMounted.current) {
        return;
      }

      if (branchResponse?.status === 200) {
        const branches = Array.isArray(
          branchResponse?.data?.data
        )
          ? branchResponse.data.data
          : [];

        setGetDataBranch(branches);

        if (branches.length > 0) {
          setForm2((previous) => ({
            ...previous,
            ysb_branch_id:
              branches[0]?.branch_code || "",
          }));
        }
      }

      if (semesterResponse?.status === 200) {
        const semesters = Array.isArray(
          semesterResponse?.data?.data
        )
          ? semesterResponse.data.data
          : [];

        const activeSemester =
          semesters.find(
            (semester) =>
              Number(semester?.status) === 1
          ) || semesters[0];

        setGetDataSemesterMap(semesters);

        if (activeSemester) {
          setNamaTA(
            activeSemester?.name_year || ""
          );

          setNamaSmstr(
            activeSemester?.semester || ""
          );

          setForm2((previous) => ({
            ...previous,
            ysb_semester_id:
              activeSemester?.id || "",
          }));
        }
      }
    } catch (error) {
      if (
        error?.name !== "CanceledError" &&
        error?.code !== "ERR_CANCELED"
      ) {
        swal({
          title: "Gagal",
          text:
            error?.response?.data?.message ||
            error?.message ||
            "Terjadi kesalahan",
          icon: "error",
        });
      }
    }
  }, [
    fetchParams,
    storageBranchGroping,
    storageLevel,
  ]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  const fetchTypeLeger = useCallback(async () => {
    setLoadingTypeLeger(true);

    try {
      const response = await APISD.get(
        "/api/type-leger",
        {
          ...fetchParams,

          /*
           * Disesuaikan dengan body GET
           * pada screenshot API.
           */
          data: {
            page: 1,
            limit: 1000,
            ascending: true,
            search: "",
            branch: "",
            level: storageLevel,
          },
        }
      );

      if (response?.status === 200) {
        const typeLeger = Array.isArray(
          response?.data?.data
        )
          ? [...response.data.data].reverse()
          : [];

        setGetDataTypeLeger(typeLeger);

        setSelectedTypeLeger((previous) => {
          const selectedStillExists =
            typeLeger.some(
              (item) =>
                String(item?.id) ===
                String(previous)
            );

          if (selectedStillExists) {
            return previous;
          }

          return typeLeger[0]?.id || "";
        });
      }
    } catch (error) {
      console.error(error);

      setGetDataTypeLeger([]);
      setSelectedTypeLeger("");

      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Gagal mengambil data tipe leger",
        icon: "error",
      });
    } finally {
      setLoadingTypeLeger(false);
    }
  }, [fetchParams, storageLevel]);

  useEffect(() => {
    fetchTypeLeger();
  }, [fetchTypeLeger]);

  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      initSchoolDone.current = false;
      initLevelDone.current = false;
      initKelasDone.current = false;

      setLoadingSchool(true);
      setGetDataSchool([]);
      setGetDataLevel([]);
      setGetDataKelas([]);

      try {
        const response = await APIMS.get(
          `/api/access/schools?page=1&limit=1000&ascending=1&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let schools = Array.isArray(
            response?.data?.data
          )
            ? response.data.data
            : [];

          if (
            storageLevel === "developer" ||
            storageLevel === "superadmin"
          ) {
            schools = schools.filter(
              (school) =>
                school?.ysb_branch_id ===
                branchId
            );
          }

          schools = removeBasementBekasi(
            schools,
            branchId
          );

          schools = sortSchools(schools);

          setGetDataSchool(schools);

          setForm2((previous) => ({
            ...previous,
            ysb_school_id:
              schools[0]?.school_code || "",
            ysb_grade_level_id: "",
            ysb_kelas_id: "",
          }));
        }
      } catch (error) {
        console.error(error);

        setGetDataSchool([]);
        setGetDataLevel([]);
        setGetDataKelas([]);

        setForm2((previous) => ({
          ...previous,
          ysb_school_id: "",
          ysb_grade_level_id: "",
          ysb_kelas_id: "",
        }));

        swal({
          title: "Gagal",
          text:
            error?.response?.data?.message ||
            "Gagal mengambil data sekolah",
          icon: "error",
          timer: 3000,
          buttons: false,
        });
      } finally {
        initSchoolDone.current = true;
        setLoadingSchool(false);
        setLoading(false);
      }
    },
    [
      fetchParams,
      removeBasementBekasi,
      sortSchools,
      storageLevel,
    ]
  );

  useEffect(() => {
    if (!form2.ysb_branch_id) {
      return;
    }

    fetchSchoolsByBranch(
      form2.ysb_branch_id
    );
  }, [
    form2.ysb_branch_id,
    fetchSchoolsByBranch,
  ]);

  const fetchLevelsBySchool = useCallback(
    async (schoolId, branchId) => {
      if (!schoolId) {
        return;
      }

      initLevelDone.current = false;
      initKelasDone.current = false;

      setLoadingLevel(true);
      setGetDataLevel([]);
      setGetDataKelas([]);

      try {
        const response = await APIMS.get(
          `/api/grade-levels?page=1&limit=1000&ascending=1&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let levels = Array.isArray(
            response?.data?.data
          )
            ? response.data.data
            : [];

          levels = levels.filter(
            (level) =>
              level?.ysb_school_id === schoolId
          );

          if (branchId) {
            levels = levels.filter(
              (level) =>
                level?.ysb_branch_id ===
                branchId
            );
          }

          levels = sortLevels(levels);

          setGetDataLevel(levels);

          setForm2((previous) => ({
            ...previous,
            ysb_grade_level_id:
              levels[0]?.id || "",
            ysb_kelas_id: "",
          }));

          if (levels.length === 0) {
            initKelasDone.current = true;
          }
        }
      } catch (error) {
        console.error(error);

        setGetDataLevel([]);
        setGetDataKelas([]);

        setForm2((previous) => ({
          ...previous,
          ysb_grade_level_id: "",
          ysb_kelas_id: "",
        }));

        swal({
          title: "Gagal",
          text:
            error?.response?.data?.message ||
            "Gagal mengambil data tingkatan",
          icon: "error",
          timer: 3000,
          buttons: false,
        });
      } finally {
        initLevelDone.current = true;
        setLoadingLevel(false);
      }
    },
    [
      fetchParams,
      sortLevels,
      storageLevel,
    ]
  );

  useEffect(() => {
    if (!form2.ysb_school_id) {
      setGetDataLevel([]);
      setGetDataKelas([]);

      setForm2((previous) => ({
        ...previous,
        ysb_grade_level_id: "",
        ysb_kelas_id: "",
      }));

      return;
    }

    fetchLevelsBySchool(
      form2.ysb_school_id,
      form2.ysb_branch_id
    );
  }, [
    form2.ysb_school_id,
    form2.ysb_branch_id,
    fetchLevelsBySchool,
  ]);

  const fetchKelasByLevel = useCallback(
    async (
      gradeLevelId,
      schoolId,
      branchId
    ) => {
      if (!gradeLevelId) {
        return;
      }

      initKelasDone.current = false;

      setLoadingKelas(true);
      setGetDataKelas([]);

      try {
        const response = await APIMS.get(
          `/api/kelas?page=1&limit=1000&ascending=1&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (response?.status === 200) {
          let classes = Array.isArray(
            response?.data?.data
          )
            ? response.data.data
            : [];

          classes = classes.filter(
            (item) =>
              item?.ysb_grade_level_id ===
              gradeLevelId
          );

          if (schoolId) {
            classes = classes.filter(
              (item) =>
                item?.ysb_school_id === schoolId
            );
          }

          if (branchId) {
            classes = classes.filter(
              (item) =>
                item?.ysb_branch_id === branchId
            );
          }

          classes = sortKelas(classes);

          setGetDataKelas(classes);

          setForm2((previous) => ({
            ...previous,
            ysb_kelas_id:
              classes[0]?.id || "",
          }));
        }
      } catch (error) {
        console.error(error);

        setGetDataKelas([]);

        setForm2((previous) => ({
          ...previous,
          ysb_kelas_id: "",
        }));

        swal({
          title: "Gagal",
          text:
            error?.response?.data?.message ||
            "Gagal mengambil data kelas",
          icon: "error",
          timer: 3000,
          buttons: false,
        });
      } finally {
        initKelasDone.current = true;
        setLoadingKelas(false);
      }
    },
    [
      fetchParams,
      sortKelas,
      storageLevel,
    ]
  );

  useEffect(() => {
    if (!form2.ysb_grade_level_id) {
      setGetDataKelas([]);

      setForm2((previous) => ({
        ...previous,
        ysb_kelas_id: "",
      }));

      return;
    }

    fetchKelasByLevel(
      form2.ysb_grade_level_id,
      form2.ysb_school_id,
      form2.ysb_branch_id
    );
  }, [
    form2.ysb_grade_level_id,
    form2.ysb_school_id,
    form2.ysb_branch_id,
    fetchKelasByLevel,
  ]);

  useEffect(() => {
    const schoolReady =
      initSchoolDone.current &&
      !loadingSchool &&
      Boolean(form2.ysb_school_id);

    const levelReady =
      initLevelDone.current &&
      !loadingLevel &&
      Boolean(form2.ysb_grade_level_id);

    const kelasReady =
      initKelasDone.current &&
      !loadingKelas &&
      Boolean(form2.ysb_kelas_id);

    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !schoolReady ||
      !levelReady ||
      !kelasReady
    ) {
      return;
    }

    firstLoadDone.current = true;
    setHasSearched(true);
    setIsFirstLoad(false);
    setIsFilterDirty(false);
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
    loadingSchool,
    loadingLevel,
    loadingKelas,
  ]);

  const isFilterComplete =
    isFilterDirty &&
    Boolean(form2.ysb_semester_id) &&
    Boolean(form2.ysb_branch_id) &&
    Boolean(form2.ysb_school_id) &&
    Boolean(form2.ysb_grade_level_id) &&
    Boolean(form2.ysb_kelas_id) &&
    !loadingSchool &&
    !loadingLevel &&
    !loadingKelas;

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm2((previous) => ({
      ...previous,
      [name]: value,
    }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  const handleAcademicYearChange = (
    event
  ) => {
    const selectedYear = event.target.value;

    const semesters = getDataSemesterMap
      .filter(
        (semester) =>
          semester?.name_year === selectedYear
      )
      .sort(
        (a, b) =>
          Number(a?.semester || 0) -
          Number(b?.semester || 0)
      );

    const selectedSemester =
      semesters.find(
        (semester) =>
          Number(semester?.status) === 1
      ) || semesters[0];

    setNamaTA(selectedYear);

    setNamaSmstr(
      selectedSemester?.semester || ""
    );

    setForm2((previous) => ({
      ...previous,
      ysb_semester_id:
        selectedSemester?.id || "",
    }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  const handleSemesterChange = (
    semester
  ) => {
    setNamaSmstr(semester?.semester || "");

    setForm2((previous) => ({
      ...previous,
      ysb_semester_id: semester?.id || "",
    }));

    setHasSearched(true);
    setIsFilterDirty(false);
  };

  const handleCari = async () => {
    if (
      loadingSchool ||
      loadingLevel ||
      loadingKelas
    ) {
      swal({
        title: "Mohon tunggu",
        text:
          "Data sekolah, tingkatan, atau kelas masih dimuat.",
        icon: "info",
        timer: 2200,
        buttons: false,
      });

      return;
    }

    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_grade_level_id ||
      !form2.ysb_kelas_id
    ) {
      swal({
        title: "Filter belum lengkap",
        text:
          "Pastikan Tahun Ajaran, Cabang, Sekolah, Tingkatan, dan Kelas sudah dipilih.",
        icon: "warning",
      });

      return;
    }

    setIsFetching(true);
    setHasSearched(false);
    setSearchFinalValue("");
    setSearchRawValue("");
    setSearchSpecialValue("");

    try {
      /*
       * Endpoint isi data leger belum tersedia.
       * Untuk sementara menampilkan konten kosong.
       */
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (error) {
      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

  const fetchFinalValue = useCallback(async () => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_kelas_id
    ) {
      return;
    }

    setLoadingFinalValue(true);

    try {
      const response = await APISD.get(
        "/api/leger/final-value",
        {
          ...fetchParams,
          params: {
            ysb_academic_year_id:
              selectedSemesterData
                ?.ysb_academic_year_id ||
              selectedSemesterData
                ?.academic_year_id ||
              selectedSemesterData
                ?.ysb_tahun_ajaran_id ||
              "",
            ysb_semester_id:
              form2.ysb_semester_id,
            ysb_branch_id: form2.ysb_branch_id,
            ysb_school_id: form2.ysb_school_id,
            ysb_kelas_id: form2.ysb_kelas_id,
          },
        }
      );

      const result = response?.data?.data || {};

      setFinalValueHeaders(
        Array.isArray(result?.header)
          ? result.header
          : []
      );
      setFinalValueStudents(
        Array.isArray(result?.data_murid)
          ? result.data_murid
          : []
      );
    } catch (error) {
      console.error(error);
      setFinalValueHeaders([]);
      setFinalValueStudents([]);

      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Gagal mengambil data nilai akhir semester",
        icon: "error",
      });
    } finally {
      setLoadingFinalValue(false);
    }
  }, [
    fetchParams,
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_kelas_id,
    selectedSemesterData,
  ]);

  const fetchMatpel = useCallback(async (currentMatpel = "") => {
    if (!form2.ysb_branch_id) return;
    setLoadingMatpel(true);
    setLoadingSpecialMatpel(true);
    setTypeActivities([]);
    setSubActivities([]);
    setSelectedTypeActivity("");
    setSpecialValueHeaders([]);
    setSpecialValueStudents([]);

    try {
      const response = await APISD.get("/api/config-matpels", {
        ...fetchParams,
        params: {
          page: 1,
          limit: 100000,
          ascending: true,
          ysb_branch_id: form2.ysb_branch_id,
          ysb_grade_level_id: form2.ysb_grade_level_id,
          ysb_academic_year_id:
            selectedSemesterData?.ysb_academic_year_id ||
            selectedSemesterData?.academic_year_id ||
            selectedSemesterData?.ysb_tahun_ajaran_id ||
            "",
        },
      });

      let matpels = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];
      matpels = matpels
        .filter(
          (item) =>
            !item?.ysb_branch_id ||
            String(item.ysb_branch_id) === String(form2.ysb_branch_id)
        )
        .filter(
          (item, index, rows) =>
            rows.findIndex(
              (row) =>
                String(row?.ysb_matpel_id || row?.id) ===
                String(item?.ysb_matpel_id || item?.id)
            ) === index
        )
        .sort((a, b) =>
          String(a?.name_matpel || "").localeCompare(
            String(b?.name_matpel || ""),
            "id",
            { numeric: true, sensitivity: "base" }
          )
        );

      const kokurikulerMatpels = matpels.filter((item) => {
        const matpelType =
          item?.matpel_type ??
          item?.ysb_matpel?.matpel_type ??
          item?.type_matpel;

        return String(matpelType) === "1";
      });

      const nextSelectedMatpel =
        matpels.some(
          (item) =>
            String(item?.ysb_matpel_id || item?.id) ===
            String(currentMatpel)
        )
          ? currentMatpel
          : matpels[0]?.ysb_matpel_id || matpels[0]?.id || "";
      const nextSpecialMatpel =
        kokurikulerMatpels.some(
          (item) =>
            String(item?.ysb_matpel_id || item?.id) ===
            String(selectedSpecialMatpel)
        )
          ? selectedSpecialMatpel
          : kokurikulerMatpels[0]?.ysb_matpel_id ||
            kokurikulerMatpels[0]?.id ||
            "";

      setGetDataMatpel(matpels);
      setSelectedMatpel(nextSelectedMatpel);
      setSpecialMatpels(kokurikulerMatpels);
      setSelectedSpecialMatpel(nextSpecialMatpel);

      return {
        rawMatpelId: nextSelectedMatpel,
        specialMatpelId: nextSpecialMatpel,
      };
    } catch (error) {
      console.error(error);
      setGetDataMatpel([]);
      setSelectedMatpel("");
      setSpecialMatpels([]);
      setSelectedSpecialMatpel("");
      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Gagal mengambil data mata pelajaran",
        icon: "error",
      });

      return { rawMatpelId: "", specialMatpelId: "" };
    } finally {
      setLoadingMatpel(false);
      setLoadingSpecialMatpel(false);
    }
  }, [
    fetchParams,
    form2.ysb_branch_id,
    form2.ysb_grade_level_id,
    selectedSemesterData,
    selectedSpecialMatpel,
  ]);

  const fetchRawValue = useCallback(async (matpelId) => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_kelas_id ||
      !matpelId
    ) return;

    setLoadingRawValue(true);
    try {
      const response = await APISD.get("/api/leger/raw-value", {
        ...fetchParams,
        params: {
          ysb_academic_year_id:
            selectedSemesterData?.ysb_academic_year_id ||
            selectedSemesterData?.academic_year_id ||
            selectedSemesterData?.ysb_tahun_ajaran_id ||
            "",
          ysb_semester_id: form2.ysb_semester_id,
          ysb_branch_id: form2.ysb_branch_id,
          ysb_school_id: form2.ysb_school_id,
          ysb_kelas_id: form2.ysb_kelas_id,
          ysb_matpel_id: matpelId,
        },
      });
      const result = response?.data?.data || {};
      setRawValueHeaders(Array.isArray(result?.header) ? result.header : []);
      setRawValueStudents(Array.isArray(result?.data_murid) ? result.data_murid : []);
      setRawValueWeights(
        result?.bobot && typeof result.bobot === "object" ? result.bobot : {}
      );
    } catch (error) {
      console.error(error);
      setRawValueHeaders([]);
      setRawValueStudents([]);
      setRawValueWeights({});
      swal({
        title: "Gagal",
        text: error?.response?.data?.message || "Gagal mengambil data nilai mentah",
        icon: "error",
      });
    } finally {
      setLoadingRawValue(false);
    }
  }, [fetchParams, form2.ysb_semester_id, form2.ysb_branch_id, form2.ysb_school_id, form2.ysb_kelas_id, selectedSemesterData]);

  const getTypeActivityId = useCallback(
    (item) => item?.ysb_type_activities_id || item?.id || "",
    []
  );

  const isActivityInSelectedSemester = useCallback(
    (item) => {
      const activitySemesterId =
        item?.ysb_semester_id ??
        item?.semester_id ??
        item?.ysb_semester?.id ??
        (typeof item?.semester === "object" ? item?.semester?.id : null);

      if (activitySemesterId !== null && activitySemesterId !== undefined) {
        return (
          String(activitySemesterId) === String(form2.ysb_semester_id)
        );
      }

      const activitySemesterNumber =
        item?.semester_number ??
        item?.semester_ke ??
        item?.ysb_semester?.semester ??
        (typeof item?.semester !== "object" ? item?.semester : null);
      const selectedSemesterNumber = selectedSemesterData?.semester;

      if (
        activitySemesterNumber !== null &&
        activitySemesterNumber !== undefined &&
        selectedSemesterNumber !== null &&
        selectedSemesterNumber !== undefined
      ) {
        return (
          String(activitySemesterNumber) === String(selectedSemesterNumber)
        );
      }

      return true;
    },
    [form2.ysb_semester_id, selectedSemesterData]
  );

  const fetchTypeActivities = useCallback(async (matpelId) => {
    const academicYearId =
      selectedSemesterData?.ysb_academic_year_id ||
      selectedSemesterData?.academic_year_id ||
      selectedSemesterData?.ysb_tahun_ajaran_id ||
      "";

    if (
      !academicYearId ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_kelas_id ||
      !matpelId
    ) {
      setTypeActivities([]);
      setSelectedTypeActivity("");
      return "";
    }

    setLoadingTypeActivities(true);
    try {
      const response = await APISD.get("/api/type-activities", {
        ...fetchParams,
        params: {
          page: 1,
          limit: 100000,
          ascending: true,
          search: "",
          branch: form2.ysb_branch_id,
          ysb_academic_year_id: academicYearId,
          ysb_semester_id: form2.ysb_semester_id,
          ysb_branch_id: form2.ysb_branch_id,
          ysb_school_id: form2.ysb_school_id,
          ysb_kelas_id: form2.ysb_kelas_id,
          ysb_matpel_id: matpelId,
          level: storageLevel,
        },
      });

      let activities = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      activities = activities
        .filter(isActivityInSelectedSemester)
        .filter(
          (item) =>
            !item?.ysb_matpel_id ||
            String(item.ysb_matpel_id) === String(matpelId)
        )
        .filter(
          (item, index, rows) =>
            rows.findIndex(
              (row) =>
                String(getTypeActivityId(row)) ===
                String(getTypeActivityId(item))
            ) === index
        )
        .sort((a, b) =>
          String(a?.name_activities || "").localeCompare(
            String(b?.name_activities || ""),
            "id",
            { numeric: true, sensitivity: "base" }
          )
        );

      const nextActivityId = getTypeActivityId(activities[0]);
      setTypeActivities(activities);
      setSelectedTypeActivity(nextActivityId);
      return nextActivityId;
    } catch (error) {
      console.error(error);
      setTypeActivities([]);
      setSelectedTypeActivity("");
      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Gagal mengambil data jenis aktivitas/kegiatan",
        icon: "error",
      });
      return "";
    } finally {
      setLoadingTypeActivities(false);
    }
  }, [
    fetchParams,
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_kelas_id,
    getTypeActivityId,
    isActivityInSelectedSemester,
    selectedSemesterData,
    storageLevel,
  ]);

  const fetchSubActivities = useCallback(async (typeActivityId) => {
    if (!typeActivityId) {
      setSubActivities([]);
      return [];
    }

    setLoadingSubActivities(true);
    try {
      const response = await APISD.get("/api/sub-activities", {
        ...fetchParams,
        data: {
          page: 1,
          limit: 100000,
          ascending: true,
          search: "",
          branch: form2.ysb_branch_id,
          ysb_type_activities_id: typeActivityId,
          level: storageLevel,
        },
      });

      let aspects = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

      aspects = aspects
        .filter(
          (item) =>
            String(item?.ysb_type_activities_id || "") ===
            String(typeActivityId)
        )
        .sort((a, b) =>
          String(a?.name_sub_activities || "").localeCompare(
            String(b?.name_sub_activities || ""),
            "id",
            { numeric: true, sensitivity: "base" }
          )
        );

      setSubActivities(aspects);
      return aspects;
    } catch (error) {
      console.error(error);
      setSubActivities([]);
      swal({
        title: "Gagal",
        text: error?.response?.data?.message || "Gagal mengambil data aspek",
        icon: "error",
      });
      return [];
    } finally {
      setLoadingSubActivities(false);
    }
  }, [fetchParams, form2.ysb_branch_id, storageLevel]);

  const fetchSpecialValue = useCallback(async (matpelId, typeActivityId) => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id ||
      !form2.ysb_kelas_id ||
      !matpelId ||
      !typeActivityId
    ) {
      setSpecialValueHeaders([]);
      setSpecialValueStudents([]);
      return;
    }

    setLoadingSpecialValue(true);
    try {
      const response = await APISD.get("/api/leger/special-value", {
        ...fetchParams,
        params: {
          ysb_academic_year_id:
            selectedSemesterData?.ysb_academic_year_id ||
            selectedSemesterData?.academic_year_id ||
            selectedSemesterData?.ysb_tahun_ajaran_id ||
            "",
          ysb_semester_id: form2.ysb_semester_id,
          ysb_branch_id: form2.ysb_branch_id,
          ysb_school_id: form2.ysb_school_id,
          ysb_kelas_id: form2.ysb_kelas_id,
          ysb_matpel_id: matpelId,
          ysb_type_activities_id: typeActivityId,
        },
      });

      const result = response?.data?.data || {};
      setSpecialValueHeaders(
        Array.isArray(result?.header) ? result.header : []
      );
      setSpecialValueStudents(
        Array.isArray(result?.data_murid) ? result.data_murid : []
      );
    } catch (error) {
      console.error(error);
      setSpecialValueHeaders([]);
      setSpecialValueStudents([]);
      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          "Gagal mengambil data nilai khusus",
        icon: "error",
      });
    } finally {
      setLoadingSpecialValue(false);
    }
  }, [
    fetchParams,
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_kelas_id,
    selectedSemesterData,
  ]);

  useEffect(() => {
    if (!hasSearched) return;

    const filterKey = [
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
      form2.ysb_grade_level_id,
      form2.ysb_kelas_id,
    ].join("|");

    if (loadedTabDataKey.current === filterKey) return;

    loadedTabDataKey.current = filterKey;

    const fetchAllTabData = async () => {
      const [, matpelResult] = await Promise.all([
        fetchFinalValue(),
        fetchMatpel(),
      ]);

      if (matpelResult?.rawMatpelId) {
        await fetchRawValue(matpelResult.rawMatpelId);
      }

      if (matpelResult?.specialMatpelId) {
        const activityId = await fetchTypeActivities(
          matpelResult.specialMatpelId
        );
        await fetchSubActivities(activityId);

        if (activityId) {
          await fetchSpecialValue(
            matpelResult.specialMatpelId,
            activityId
          );
        }
      }
    };

    fetchAllTabData();
  }, [
    hasSearched,
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
    fetchFinalValue,
    fetchMatpel,
    fetchRawValue,
    fetchTypeActivities,
    fetchSubActivities,
    fetchSpecialValue,
  ]);

  const getRawHeaderWeightInfo = useCallback(
    (title) => {
      const normalizedTitle = String(title || "").trim().toLowerCase();
      const formatWeight = (value) =>
        value === null || value === undefined || value === "" ? "-" : `${value}%`;

      if (normalizedTitle === "rata-rata sumatif akhir") {
        return `Bobot ASTS: ${formatWeight(
          rawValueWeights?.asts
        )}\nBobot ASAS: ${formatWeight(rawValueWeights?.asas)}`;
      }

      if (normalizedTitle === "nilai rapor") {
        return `Bobot Sumatif Harian: ${formatWeight(
          rawValueWeights?.sumatif_harian
        )}\nBobot Sumatif Akhir: ${formatWeight(
          rawValueWeights?.sumatif_akhir
        )}`;
      }

      return "";
    },
    [rawValueWeights]
  );

  const rawLeafHeaders = useMemo(
    () => rawValueHeaders.flatMap((header) => {
      const children = Array.isArray(header?.ysb_matpel_tp) ? header.ysb_matpel_tp : [];
      return children.length
        ? children.map((child) => ({ ...child, parentTitle: header?.title || "-", isTp: true }))
        : [{ ...header, parentTitle: header?.title || "-", isTp: false }];
    }),
    [rawValueHeaders]
  );

  const getRawStudentValue = useCallback((student, header) => {
    if (String(header?.title || header?.parentTitle || "").toLowerCase() === "nama")
      return student?.nama_lengkap || "-";
    if (header?.isTp) {
      const item = Array.isArray(student?.data_nilai)
        ? student.data_nilai.find((value) => String(value?.ysb_matpel_tp_id) === String(header?.id))
        : null;
      return item?.score ?? "-";
    }
    const keyMap = {
      "rata-rata sumatif harian": "rata_rata_sumatif_harian",
      asts: "asts",
      asas: "asas",
      "rata-rata sumatif akhir": "rata_rata_sumatif_akhir",
      "nilai rapor": "nilai_rapor",
    };
    const key = keyMap[String(header?.title || header?.parentTitle || "").toLowerCase()];
    const value = key ? student?.[key] : null;
    return value === null || value === undefined || value === "" ? "-" : value;
  }, []);

  const specialHeaderGroups = useMemo(
    () =>
      specialValueHeaders.map((header) => {
        const activities = Array.isArray(header?.type_activities)
          ? header.type_activities
          : [];
        const normalizedActivities = activities.map((activity) => {
          const subActivities = Array.isArray(activity?.sub_activities)
            ? [...activity.sub_activities].sort((a, b) =>
                String(a?.name_sub_activities || "").localeCompare(
                  String(b?.name_sub_activities || ""),
                  "id",
                  { numeric: true, sensitivity: "base" }
                )
              )
            : [];

          return {
            ...activity,
            subActivities,
            leafCount: Math.max(subActivities.length, 1),
          };
        });

        return {
          header,
          activities: normalizedActivities,
          leafCount: normalizedActivities.length
            ? normalizedActivities.reduce(
                (total, activity) => total + activity.leafCount,
                0
              )
            : 1,
        };
      }),
    [specialValueHeaders]
  );

  const specialLeafHeaders = useMemo(
    () =>
      specialHeaderGroups.flatMap(({ header, activities }) => {
        if (activities.length === 0) {
          return [{
            ...header,
            parentTitle: header?.title || "-",
            isAspect: false,
          }];
        }

        return activities.flatMap((activity) =>
          activity.subActivities.length
            ? activity.subActivities.map((subActivity) => ({
                ...subActivity,
                parentTitle: header?.title || "-",
                activityId: activity?.id,
                activityName: activity?.name_activities || "-",
                examId: header?.exam_id,
                isAspect: true,
              }))
            : [{
                ...activity,
                parentTitle: header?.title || "-",
                activityName: activity?.name_activities || "-",
                isAspect: false,
              }]
        );
      }),
    [specialHeaderGroups]
  );

  const getSpecialStudentValue = useCallback((student, header) => {
    const title = String(header?.title || header?.parentTitle || "").toLowerCase();
    if (title === "nama") return student?.nama_lengkap || "-";

    const studentScores = Array.isArray(student?.nilai) ? student.nilai : [];
    const normalizedParentTitle = String(header?.parentTitle || "")
      .trim()
      .toLowerCase();

    // Satu sub activity dapat dipakai pada beberapa kegiatan (contoh KO 1 dan
    // KO 2). Karena itu ID aspek saja tidak cukup: cocokkan juga kegiatannya
    // agar nilai dari kegiatan lain yang null tidak terambil lebih dahulu.
    const score =
      studentScores.find(
        (item) =>
          String(item?.ysb_sub_activities_id || "") ===
            String(header?.id || "") &&
          String(item?.kegiatan || "").trim().toLowerCase() ===
            normalizedParentTitle
      ) ||
      studentScores.find(
        (item) =>
          String(item?.ysb_sub_activities_id || "") ===
          String(header?.id || "")
      );

    const value =
      score?.score_value ??
      score?.score_text ??
      score?.score ??
      null;

    return value === null || value === undefined || value === "" ? "-" : value;
  }, []);

  const downloadStyledExcel = useCallback((rows, fileName, options = {}) => {
    const escapeHtml = (value) =>
      String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

    const widthHeaders = options?.leafHeaders || rows[0] || [];
    const columnWidths = widthHeaders.map((header, index) => {
      const title = String(header || "").toLowerCase();
      if (index === 0) return 55;
      if (title.includes("nama")) return 240;
      return Math.min(Math.max(String(header || "").length * 8, 110), 220);
    });

    const headerRows = Array.isArray(options?.headerRows)
      ? options.headerRows
          .map(
            (headerRow) => `
              <tr>
                ${headerRow
                  .map((cell) => {
                    const colSpan = Math.max(Number(cell?.colSpan) || 1, 1);
                    const rowSpan = Math.max(Number(cell?.rowSpan) || 1, 1);
                    const spanAttributes = `${colSpan > 1 ? ` colspan="${colSpan}"` : ""}${
                      rowSpan > 1 ? ` rowspan="${rowSpan}"` : ""
                    }`;
                    return `<th${spanAttributes} style="text-align:center;">${escapeHtml(
                      cell?.value ?? "-"
                    )}</th>`;
                  })
                  .join("")}
              </tr>`
          )
          .join("")
      : "";

    const bodyRows = options?.headerRows ? rows : rows.slice(1);
    const defaultHeaderRow = options?.headerRows
      ? ""
      : `
          <tr>
            ${(rows[0] || [])
              .map(
                (cell, columnIndex) =>
                  `<th style="text-align:${columnIndex === 1 ? "left" : "center"};">${escapeHtml(
                    cell
                  )}</th>`
              )
              .join("")}
          </tr>`;

    const tableRows = bodyRows
      .map(
        (row) => `
          <tr>
            ${row
              .map((cell, columnIndex) => {
                const alignment =
                  columnIndex === 0
                    ? "center"
                    : columnIndex === 1
                    ? "left"
                    : "center";
                return `<td style="text-align:${alignment};">${escapeHtml(
                  cell
                )}</td>`;
              })
              .join("")}
          </tr>`
      )
      .join("");

    const excelDocument = `
      <!DOCTYPE html>
      <html xmlns:o="urn:schemas-microsoft-com:office:office"
            xmlns:x="urn:schemas-microsoft-com:office:excel"
            xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <meta charset="UTF-8" />
          <!--[if gte mso 9]>
          <xml>
            <x:ExcelWorkbook>
              <x:ExcelWorksheets>
                <x:ExcelWorksheet>
                  <x:Name>Data Nilai</x:Name>
                  <x:WorksheetOptions><x:Selected/></x:WorksheetOptions>
                </x:ExcelWorksheet>
              </x:ExcelWorksheets>
            </x:ExcelWorkbook>
          </xml>
          <![endif]-->
          <style>
            table { border-collapse: collapse; font-family: Calibri, Arial, sans-serif; font-size: 11pt; }
            th { background: #3f5bea; color: #ffffff; font-weight: 700; border: 1px solid #1f4e78; padding: 8px 10px; vertical-align: middle; white-space: normal; }
            td { color: #1f2937; border: 1px solid #b8c2cc; padding: 6px 10px; vertical-align: middle; white-space: nowrap; }
            tr:nth-child(even) td { background: #f3f7fb; }
          </style>
        </head>
        <body>
          <table>
            <colgroup>
              ${columnWidths
                .map((width) => `<col style="width:${width}px" />`)
                .join("")}
            </colgroup>
            <thead>${headerRows || defaultHeaderRow}</thead>
            <tbody>
            ${tableRows}
            </tbody>
          </table>
        </body>
      </html>`;

    const blob = new Blob(["\uFEFF", excelDocument], {
      type: "application/vnd.ms-excel;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName.replace(/[\\/:*?"<>|]/g, "-")}.xls`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, []);

  const handleDownloadRawValue = async () => {
    if (!getDataMatpel.length || downloadingRawValue) {
      swal({
        title: "Data belum tersedia",
        text: "Mata pelajaran belum tersedia untuk diunduh.",
        icon: "info",
      });
      return;
    }

    const escapeXml = (value) =>
      String(value ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");

    const getCellType = (value) =>
      typeof value === "number" && Number.isFinite(value) ? "Number" : "String";

    const makeCell = (value, styleId, attributes = "") =>
      `<Cell ss:StyleID="${styleId}"${attributes}><Data ss:Type="${getCellType(
        value
      )}">${escapeXml(value)}</Data></Cell>`;

    const usedSheetNames = new Set();
    const getUniqueSheetName = (name, index) => {
      const baseName = String(name || `Matpel ${index + 1}`)
        .replace(/[\\/:?*\[\]]/g, " ")
        .replace(/\s+/g, " ")
        .trim() || `Matpel ${index + 1}`;
      let sheetName = baseName.slice(0, 31);
      let suffixNumber = 2;

      while (usedSheetNames.has(sheetName.toLowerCase())) {
        const suffix = ` (${suffixNumber})`;
        sheetName = `${baseName.slice(0, 31 - suffix.length)}${suffix}`;
        suffixNumber += 1;
      }

      usedSheetNames.add(sheetName.toLowerCase());
      return sheetName;
    };

    setDownloadingRawValue(true);

    try {
      const responses = await Promise.allSettled(
        getDataMatpel.map((matpel) => {
          const matpelId = matpel?.ysb_matpel_id || matpel?.id;

          return APISD.get("/api/leger/raw-value", {
            ...fetchParams,
            params: {
              ysb_academic_year_id:
                selectedSemesterData?.ysb_academic_year_id ||
                selectedSemesterData?.academic_year_id ||
                selectedSemesterData?.ysb_tahun_ajaran_id ||
                "",
              ysb_semester_id: form2.ysb_semester_id,
              ysb_branch_id: form2.ysb_branch_id,
              ysb_school_id: form2.ysb_school_id,
              ysb_kelas_id: form2.ysb_kelas_id,
              ysb_matpel_id: matpelId,
            },
          });
        })
      );

      const failedMatpels = [];
      const worksheets = responses
        .map((response, matpelIndex) => {
          const matpel = getDataMatpel[matpelIndex];
          const matpelName = matpel?.name_matpel || `Matpel ${matpelIndex + 1}`;

          if (response.status !== "fulfilled") {
            failedMatpels.push(matpelName);
            return "";
          }

          const result = response.value?.data?.data || {};
          const headers = Array.isArray(result?.header) ? result.header : [];
          const students = Array.isArray(result?.data_murid) ? result.data_murid : [];
          const leafHeaders = headers.flatMap((header) => {
            const children = Array.isArray(header?.ysb_matpel_tp)
              ? header.ysb_matpel_tp
              : [];

            return children.length
              ? children.map((child) => ({
                  ...child,
                  parentTitle: header?.title || "-",
                  isTp: true,
                }))
              : [{ ...header, parentTitle: header?.title || "-", isTp: false }];
          });

          const firstHeaderCells = [
            makeCell("No", "Header", ' ss:MergeDown="1"'),
            ...headers.map((header) => {
              const children = Array.isArray(header?.ysb_matpel_tp)
                ? header.ysb_matpel_tp
                : [];
              const mergeAttribute = children.length
                ? children.length > 1
                  ? ` ss:MergeAcross="${children.length - 1}"`
                  : ""
                : ' ss:MergeDown="1"';

              return makeCell(
                header?.title || "-",
                String(header?.title || "").toLowerCase() === "nama"
                  ? "HeaderLeft"
                  : "Header",
                mergeAttribute
              );
            }),
          ].join("");

          let currentColumnIndex = 2;
          const secondHeaderCells = headers
            .map((header) => {
              const children = Array.isArray(header?.ysb_matpel_tp)
                ? header.ysb_matpel_tp
                : [];

              if (!children.length) {
                currentColumnIndex += 1;
                return "";
              }

              const childCells = children
                .map((child, childIndex) =>
                  makeCell(
                    child?.name_tp || "-",
                    "Header",
                    childIndex === 0 ? ` ss:Index="${currentColumnIndex}"` : ""
                  )
                )
                .join("");
              currentColumnIndex += children.length;
              return childCells;
            })
            .join("");

          const dataRows = students
            .map((student, studentIndex) => {
              const styleSuffix = studentIndex % 2 === 1 ? "Alt" : "";
              const cells = [
                makeCell(studentIndex + 1, `DataCenter${styleSuffix}`),
                ...leafHeaders.map((header, columnIndex) =>
                  makeCell(
                    getRawStudentValue(student, header),
                    columnIndex === 0
                      ? `DataLeft${styleSuffix}`
                      : `DataCenter${styleSuffix}`
                  )
                ),
              ].join("");

              return `<Row>${cells}</Row>`;
            })
            .join("");

          const columnDefinitions = leafHeaders
            .map((header, index) => {
              const title = String(
                header?.isTp ? header?.name_tp : header?.title || ""
              ).toLowerCase();
              const width = index === 0 && title.includes("nama") ? 220 : 115;
              return `<Column ss:AutoFitWidth="0" ss:Width="${width}"/>`;
            })
            .join("");

          const sheetName = getUniqueSheetName(matpelName, matpelIndex);
          return `
            <Worksheet ss:Name="${escapeXml(sheetName)}">
              <Table>
                <Column ss:AutoFitWidth="0" ss:Width="45"/>
                ${columnDefinitions}
                <Row ss:Height="27">${firstHeaderCells}</Row>
                <Row ss:Height="24">${secondHeaderCells}</Row>
                ${dataRows}
              </Table>
              <WorksheetOptions xmlns="urn:schemas-microsoft-com:office:excel">
                <FreezePanes/>
                <FrozenNoSplit/>
                <SplitHorizontal>2</SplitHorizontal>
                <TopRowBottomPane>2</TopRowBottomPane>
                <ActivePane>2</ActivePane>
                <ProtectObjects>False</ProtectObjects>
                <ProtectScenarios>False</ProtectScenarios>
              </WorksheetOptions>
            </Worksheet>`;
        })
        .filter(Boolean)
        .join("");

      if (!worksheets) {
        throw new Error("Semua data mata pelajaran gagal diambil.");
      }

      const workbook = `<?xml version="1.0"?>
        <?mso-application progid="Excel.Sheet"?>
        <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
          xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">
          <Styles>
            <Style ss:ID="Default" ss:Name="Normal">
              <Alignment ss:Vertical="Center"/>
              <Font ss:FontName="Calibri" ss:Size="11"/>
            </Style>
            <Style ss:ID="Header">
              <Alignment ss:Horizontal="Center" ss:Vertical="Center" ss:WrapText="1"/>
              <Borders>
                <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#1F4E78"/>
                <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#1F4E78"/>
                <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#1F4E78"/>
                <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#1F4E78"/>
              </Borders>
              <Font ss:FontName="Calibri" ss:Size="11" ss:Bold="1" ss:Color="#FFFFFF"/>
              <Interior ss:Color="#3f5bea" ss:Pattern="Solid"/>
            </Style>
            <Style ss:ID="HeaderLeft" ss:Parent="Header">
              <Alignment ss:Horizontal="Left" ss:Vertical="Center" ss:WrapText="1"/>
            </Style>
            <Style ss:ID="DataCenter">
              <Alignment ss:Horizontal="Center" ss:Vertical="Center"/>
              <Borders>
                <Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#B8C2CC"/>
                <Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#B8C2CC"/>
                <Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#B8C2CC"/>
                <Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#B8C2CC"/>
              </Borders>
            </Style>
            <Style ss:ID="DataLeft" ss:Parent="DataCenter">
              <Alignment ss:Horizontal="Left" ss:Vertical="Center"/>
            </Style>
            <Style ss:ID="DataCenterAlt" ss:Parent="DataCenter">
              <Interior ss:Color="#F3F7FB" ss:Pattern="Solid"/>
            </Style>
            <Style ss:ID="DataLeftAlt" ss:Parent="DataLeft">
              <Interior ss:Color="#F3F7FB" ss:Pattern="Solid"/>
            </Style>
          </Styles>
          ${worksheets}
        </Workbook>`;

      const blob = new Blob(["\uFEFF", workbook], {
        type: "application/vnd.ms-excel;charset=utf-8;",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Nilai-Mentah-Semua-Matpel-Semester-${namaSmstr || "-"}.xls`.replace(
        /[\\/:*?"<>|]/g,
        "-"
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      if (failedMatpels.length) {
        swal({
          title: "Unduhan selesai",
          text: `${failedMatpels.length} mata pelajaran gagal dimuat: ${failedMatpels.join(
            ", "
          )}`,
          icon: "warning",
        });
      }
    } catch (error) {
      console.error(error);
      swal({
        title: "Gagal",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Gagal mengunduh nilai mentah semua mata pelajaran.",
        icon: "error",
      });
    } finally {
      setDownloadingRawValue(false);
    }
  };

  const getStudentScore = useCallback(
    (student, header) => {
      if (!header?.matpel_id) {
        return student?.nama_lengkap || "-";
      }

      const score = Array.isArray(student?.nilai)
        ? student.nilai.find(
            (item) =>
              String(item?.matpel_id) ===
              String(header.matpel_id)
          )
        : null;

      const value = score?.nilai_rapor;
      return value === null ||
        value === undefined ||
        value === ""
        ? "-"
        : value;
    },
    []
  );

  const handleDownloadFinalValue = () => {
    if (filteredFinalValueStudents.length === 0) {
      swal({
        title: "Data belum tersedia",
        text: "Tidak ada nilai yang dapat diunduh.",
        icon: "info",
      });
      return;
    }

    const excelRows = [
      ["No", ...finalValueHeaders.map((item) => item?.title || "-")],
      ...filteredFinalValueStudents.map((student, index) => [
        index + 1,
        ...finalValueHeaders.map((header) =>
          getStudentScore(student, header)
        ),
      ]),
    ];

    const selectedClass = getDataKelas.find(
      (item) =>
        String(item?.id) ===
        String(form2.ysb_kelas_id)
    );

    downloadStyledExcel(
      excelRows,
      `Nilai-Akhir-${selectedClass?.name_kelas || "Kelas"}-Semester-${namaSmstr || "-"}`
    );
  };

  const handleDownloadSpecialValue = () => {
    if (filteredSpecialValueStudents.length === 0) {
      swal({
        title: "Data belum tersedia",
        text: "Tidak ada nilai khusus yang dapat diunduh.",
        icon: "info",
      });
      return;
    }

    const firstHeaderRow = [
      { value: "No", rowSpan: 3 },
      ...specialHeaderGroups.map(({ header, activities, leafCount }) => ({
        value: header?.title || "-",
        colSpan: leafCount,
        rowSpan: activities.length ? 1 : 3,
      })),
    ];

    const secondHeaderRow = specialHeaderGroups.flatMap(({ activities }) =>
      activities.map((activity) => ({
        value: activity?.name_activities || "-",
        colSpan: activity.leafCount,
        rowSpan: activity.subActivities.length ? 1 : 2,
      }))
    );

    const thirdHeaderRow = specialHeaderGroups.flatMap(({ activities }) =>
      activities.flatMap((activity) =>
        activity.subActivities.map((subActivity) => ({
          value: subActivity?.name_sub_activities || "-",
        }))
      )
    );

    const rows = filteredSpecialValueStudents.map((student, index) => [
      index + 1,
      ...specialLeafHeaders.map((header) =>
        getSpecialStudentValue(student, header)
      ),
    ]);

    const selectedClass = getDataKelas.find(
      (item) => String(item?.id) === String(form2.ysb_kelas_id)
    );
    const selectedActivity = typeActivities.find(
      (item) =>
        String(getTypeActivityId(item)) === String(selectedTypeActivity)
    );

    downloadStyledExcel(
      rows,
      `Nilai-Khusus-${
        selectedActivity?.name_activities || "Kegiatan"
      }-${selectedClass?.name_kelas || "Kelas"}-Semester-${namaSmstr || "-"}`,
      {
        headerRows: [firstHeaderRow, secondHeaderRow, thirdHeaderRow],
        leafHeaders: [
          "No",
          ...specialLeafHeaders.map((header) =>
            header?.isAspect
              ? header?.name_sub_activities || "-"
              : header?.title || "-"
          ),
        ],
      }
    );
  };

  return (
    <>
      <style>{`
        .leger-table-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          padding: 10px 22px;
          border-bottom: 1px solid #e5eaf3;
        }

        .leger-table-title {
          margin: 0;
          color: #111827;
          font-size: 17px;
          font-weight: 700;
        }

        .leger-semester-tabs {
          display: flex;
          gap: 4px;
          padding: 4px;
          border: 1px solid #dce3ee;
          border-radius: 12px;
          background: #f8fafc;
        }

        .leger-semester-tab {
          min-width: 100px;
          padding: 10px 14px;
          border: 0;
          border-radius: 9px;
          background: transparent;
          color: #64748b;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
        }

        .leger-semester-tab.active {
          background: #ffffff;
          color: #3f5bea;
          box-shadow:
            0 2px 8px
            rgba(15, 23, 42, 0.08);
        }

        /*
         * TAB TIPE LEGER
         */
        .leger-type-tabs-wrapper {
          width: 100%;
          padding: 18px 0px 10px;
        }

        .leger-type-tabs {
          display: flex;
          align-items: center;
          width: 100%;
          min-height: 54px;
          padding: 5px;
          overflow-x: auto;
          border: 1px solid #f1f5fb;
          // border-radius: 13px;
          background: #ffffff;
          scrollbar-width: thin;
        }

        .leger-type-tab {
          flex: 1 0 140px;
          min-width: 140px;
          padding: 11px 18px;
          border: 0;
          border-radius: 9px;
          background: transparent;
          color: #3f5bea;
          font-size: 13px;
          font-weight: 700;
          line-height: 1.3;
          text-align: center;
          white-space: nowrap;
          cursor: pointer;
          transition:
            background-color 0.2s ease,
            color 0.2s ease,
            box-shadow 0.2s ease;
        }

        .leger-type-tab:hover {
          background: #eef2ff;
        }

        .leger-type-tab.active {
          background: #3f5bea;
          color: #ffffff;
          box-shadow:
            0 4px 10px
            rgba(63, 91, 234, 0.22);
        }

        .leger-type-tab-state {
          width: 100%;
          padding: 11px 16px;
          color: #94a3b8;
          font-size: 14px;
          text-align: center;
        }

        .leger-empty-content {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          min-height: 130px;
          padding: 25px;
          color: #94a3b8;
          font-size: 14px;
          text-align: center;
        }

        .leger-final-content {
          padding: 12px 10px 12px;
        }

        .leger-final-toolbar {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-bottom: 16px;
        }

        .leger-special-content {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .leger-special-filter-row {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 18px;
        }

        .leger-special-field {
          display: flex;
          min-width: 0;
          flex-direction: column;
          gap: 7px;
        }

        .leger-special-field label {
          margin: 0;
          color: #475569;
          font-size: 12px;
          font-weight: 700;
        }

        .leger-special-field .leger-raw-subject,
        .leger-special-field .leger-final-search {
          width: 100%;
          min-width: 0;
        }

        .leger-special-search-field {
          justify-content: flex-end;
        }

        .leger-special-aspect-list {
          min-height: 46px;
          padding: 11px 16px;
          border: 1px solid #dbe3f0;
          border-radius: 13px;
          background: #f8faff;
        }

        .leger-special-aspect-list ul {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 0;
          padding: 0;
          list-style: none;
        }

        .leger-special-aspect-list li {
          position: relative;
          padding: 7px 12px 7px 25px;
          border: 1px solid #dbe4ff;
          border-radius: 9px;
          background: #ffffff;
          color: #334155;
          font-size: 13px;
          font-weight: 600;
          line-height: 1.35;
        }

        .leger-special-aspect-list li::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 11px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #3f5bea;
          transform: translateY(-50%);
        }

        .leger-special-aspect-empty {
          color: #94a3b8;
          font-size: 13px;
        }

        .leger-special-search-actions {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .leger-special-search-actions .leger-final-search {
          flex: 1;
        }

        .leger-special-search-actions .leger-final-download {
          flex: 0 0 auto;
          min-width: 165px;
        }

        .leger-final-search {
          flex: 1;
          width: 100%;
          height: 46px;
          padding: 0 18px;
          border: 1px solid #dbe3f0;
          border-radius: 13px;
          outline: none;
          color: #1f2937;
          font-size: 14px;
        }

        .leger-raw-subject {
          width: 280px;
          min-width: 240px;
          height: 46px;
          padding: 0 42px 0 16px;
          border: 1px solid #dbe3f0;
          border-radius: 13px;
          outline: none;
          background: #ffffff;
          color: #1f2937;
          font-size: 14px;
        }

        .leger-raw-subject:focus {
          border-color: #3f5bea;
          box-shadow: 0 0 0 3px rgba(63, 91, 234, 0.1);
        }

        .leger-final-table thead tr:nth-child(2) th {
          top: 70px;
          z-index: 7;
        }

        .leger-final-table thead tr:nth-child(2) th.leger-raw-subheader {
          left: auto;
          min-width: 165px;
          max-width: none;
          text-align: center;
          box-shadow: none;
        }

        .leger-final-table thead tr:nth-child(3) th {
          top: 140px;
          z-index: 7;
        }

        .leger-final-table thead tr:nth-child(3) th.leger-raw-subheader {
          left: auto;
          min-width: 165px;
          max-width: none;
          text-align: center;
          box-shadow: none;
        }

        .leger-final-table th.leger-raw-summary-header {
          background: #e8edff;
          color: #243b86;
          text-align: center !important;
        }

        .leger-final-table th.leger-raw-summary-header:hover,
        .leger-final-table th.leger-raw-summary-header:focus-within {
          z-index: 25;
        }

        .leger-raw-header-label {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 7px;
        }

        .leger-raw-weight-info {
          position: relative;
          display: inline-flex;
          flex: 0 0 auto;
          align-items: center;
          justify-content: center;
          width: 19px;
          height: 19px;
          padding: 0;
          border: 0;
          border-radius: 50%;
          background: #3f5bea;
          color: #ffffff;
          font-size: 12px;
          font-weight: 800;
          line-height: 1;
          cursor: help;
        }

        .leger-raw-weight-info::after {
          content: attr(data-tooltip);
          position: absolute;
          z-index: 40;
          top: calc(100% + 10px);
          right: 50%;
          width: max-content;
          max-width: 290px;
          padding: 9px 11px;
          border-radius: 8px;
          background: #172554;
          color: #ffffff;
          font-size: 11px;
          font-weight: 500;
          line-height: 1.45;
          text-align: left;
          white-space: pre-line;
          box-shadow: 0 8px 20px rgba(15, 23, 42, 0.2);
          opacity: 0;
          visibility: hidden;
          transform: translateX(50%) translateY(-4px);
          transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
          pointer-events: none;
        }

        .leger-raw-weight-info:hover::after,
        .leger-raw-weight-info:focus-visible::after {
          opacity: 1;
          visibility: visible;
          transform: translateX(50%) translateY(0);
        }

        /* Tooltip pada header paling kanan dibuka ke arah kiri agar tidak
           terpotong oleh batas area scroll tabel. */
        .leger-final-table thead tr:first-child th:last-child
          .leger-raw-weight-info::after {
          right: -8px;
          transform: translateX(0) translateY(-4px);
        }

        .leger-final-table thead tr:first-child th:last-child
          .leger-raw-weight-info:hover::after,
        .leger-final-table thead tr:first-child th:last-child
          .leger-raw-weight-info:focus-visible::after {
          transform: translateX(0) translateY(0);
        }

        .leger-final-search:focus {
          border-color: #3f5bea;
          box-shadow: 0 0 0 3px rgba(63, 91, 234, 0.1);
        }

        .leger-final-download {
          min-width: 154px;
          height: 46px;
          padding: 0 20px;
          border: 0;
          border-radius: 13px;
          background: #f0a000;
          color: #ffffff;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
        }

        .leger-final-download:disabled {
          cursor: not-allowed;
          opacity: 0.55;
        }

        .leger-final-table-wrap {
          width: 100%;
          max-height: calc(100vh - 210px);
          overflow: auto;
          // border: 1px solid #e2e8f0;
          // border-radius: 12px;
          scrollbar-color: #cbd5e1 transparent;
          scrollbar-width: thin;
          -webkit-overflow-scrolling: touch;
        }

        .leger-final-table-wrap.leger-raw-table-wrap {
          width: calc(100% + 40px);
          max-width: none;
          margin-right: -40px;
        }

        .leger-final-table-wrap.leger-special-table-wrap {
          width: 100%;
          max-width: 100%;
          margin-right: 0;
        }

        .leger-final-table-wrap::-webkit-scrollbar {
          width: 9px;
          height: 9px;
        }

        .leger-final-table-wrap::-webkit-scrollbar-track {
          background: transparent;
        }

        .leger-final-table-wrap::-webkit-scrollbar-thumb {
          border-radius: 999px;
          background: #cbd5e1;
        }

        .leger-final-table {
          width: max-content;
          min-width: 100%;
          border-collapse: separate;
          border-spacing: 0;
          color: #334155;
          font-size: 13px;
        }

        .leger-final-table.leger-raw-table {
          width: 100% !important;
        }

        .leger-final-table.leger-special-table {
          width: max-content !important;
          min-width: 100%;
        }

        .leger-final-table.leger-raw-table-full {
          table-layout: fixed;
        }

        .leger-final-table th,
        .leger-final-table td {
          min-width: 165px;
          height: 72px;
          padding: 14px 16px;
          border-left: 1px solid #e2e8f0;
          border-bottom: 1px solid #e2e8f0;
          text-align: center;
          white-space: nowrap;
        }

        .leger-final-table th:last-child,
        .leger-final-table td:last-child {
          border-right: 1px solid #e2e8f0;
        }

        .leger-final-table th {
          position: sticky;
          top: 0;
          z-index: 6;
          height: 70px;
          background: #f2f3fc;
          color: #172554;
          font-weight: 700;
          white-space: normal;
          vertical-align: middle;
        }

        .leger-final-table tbody tr:nth-child(even) td {
          background: #f8fafc;
        }

        .leger-final-table tbody tr:nth-child(odd) td {
          background: #ffffff;
        }

        .leger-final-header-title {
          display: block;
          min-width: 0;
          // max-width: 220px;
          line-height: 1.35;
          white-space: normal;
          overflow-wrap: break-word;
        }

        .leger-final-header-subtitle {
          display: block;
          margin-top: 3px;
          color: #52607a;
          font-size: 11px;
          font-weight: 500;
        }

        .leger-final-table thead tr:first-child th:nth-child(2),
        .leger-final-table td:nth-child(2) {
          position: sticky;
          left: 68px;
          z-index: 2;
          min-width: 250px;
          max-width: 250px;
          text-align: left;
          white-space: normal;
        }

        .leger-final-table thead tr:first-child th:nth-child(2) {
          z-index: 8;
          background: #f2f3fc;
          box-shadow: 5px 0 10px -10px rgba(0, 76, 255, 0.55);
        }

        .leger-final-table td:nth-child(2) {
          box-shadow: 5px 0 10px -10px rgba(0, 76, 255, 0.55);
          font-weight: 600;
          color: #1f2937;
        }

        .leger-final-table thead tr:first-child th:first-child,
        .leger-final-table td:first-child {
          position: sticky;
          left: 0;
          z-index: 3;
          width: 68px;
          min-width: 68px;
          max-width: 68px;
          padding-right: 8px;
          padding-left: 8px;
        }

        .leger-final-table thead tr:first-child th:first-child {
          z-index: 9;
          background: #f2f3fc;
        }

        .leger-final-number {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border: 1px solid #d4ddff;
          border-radius: 50%;
          background: #f5f7ff;
          color: #3f5bea;
          font-size: 13px;
          font-weight: 700;
          margin-left : 8px;

        }

        .leger-final-table tbody tr:last-child td {
          border-bottom: 0;
        }

        .leger-final-empty {
          padding: 32px 18px !important;
          color: #94a3b8;
          text-align: center !important;
        }

        @media (max-width: 576px) {
          .leger-final-table-wrap.leger-raw-table-wrap {
            width: 100%;
            margin-right: 0;
          }

          .leger-table-header {
            align-items: flex-start;
            flex-direction: column;
          }

          .leger-semester-tabs {
            width: 100%;
          }

          .leger-semester-tab {
            width: 100%;
            min-width: 0;
          }

          .leger-type-tabs-wrapper {
            padding: 14px 14px 8px;
          }

          .leger-type-tab {
            flex: 0 0 auto;
            min-width: 135px;
          }

          .leger-final-content {
            padding: 8px 14px 20px;
          }

          .leger-final-toolbar {
            align-items: stretch;
            flex-direction: column;
            gap: 10px;
          }

          .leger-special-filter-row {
            grid-template-columns: 1fr;
            gap: 10px;
          }

          .leger-special-search-actions {
            align-items: stretch;
            flex-direction: column;
          }

          .leger-final-download {
            width: 100%;
          }

          .leger-raw-subject {
            width: 100%;
          }

          .leger-final-table th,
          .leger-final-table td {
            min-width: 145px;
          }

          .leger-final-table th:nth-child(2),
          .leger-final-table td:nth-child(2) {
            min-width: 205px;
            max-width: 205px;
          }
        }
      `}</style>

      <div className="body sims-page">
        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon
                  icon={faRectangleList}
                />
              </span>

              <h4 className="page-title-text">
                Leger
              </h4>
            </div>

            <div className="ml-auto menu-navigation-wrapper">
              <Link
                to="/leger-siakad/type-leger"
                className="menu-navigation-button"
              >
                Tipe Leger
              </Link>

              <Link
                to="/leger-siakad/standar-calculation"
                className="menu-navigation-button"
              >
                Atur Bobot
              </Link>
            </div>
          </div>
        </div>

        <div className="body-content sims-content">
          {loading ? (
            <div className="sims-filter-card">
              {Array.from({
                length: 6,
              }).map((_, index) => (
                <div
                  key={`filter-skeleton-${index}`}
                  className="shimmer sims-filter-skeleton"
                />
              ))}

            </div>
          ) : (
            <div className="sims-filter-card">
              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Tahun Ajaran
                </label>

                <select
                  className="sims-filter-select"
                  name="academic_year"
                  value={namaTA}
                  onChange={
                    handleAcademicYearChange
                  }
                >
                  <option value="" disabled>
                    Pilih Tahun Ajaran
                  </option>

                  {academicYears.map(
                    (academicYear, index) => (
                      <option
                        key={
                          academicYear || index
                        }
                        value={academicYear}
                      >
                        {academicYear}
                      </option>
                    )
                  )}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Cabang
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_branch_id"
                  value={form2.ysb_branch_id}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Pilih Cabang
                  </option>

                  {getDataBranch.map(
                    (branch, index) => (
                      <option
                        key={
                          branch?.branch_code ||
                          index
                        }
                        value={
                          branch?.branch_code
                        }
                      >
                        {branch?.branch_name}
                      </option>
                    )
                  )}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Sekolah
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_school_id"
                  value={form2.ysb_school_id}
                  onChange={handleChange}
                  disabled={
                    loadingSchool ||
                    !form2.ysb_branch_id
                  }
                >
                  <option value="" disabled>
                    {!form2.ysb_branch_id
                      ? "Pilih Cabang terlebih dahulu"
                      : loadingSchool
                      ? "Memuat data sekolah..."
                      : "Pilih Sekolah"}
                  </option>

                  {!loadingSchool &&
                    getDataSchool.map(
                      (school, index) => (
                        <option
                          key={
                            school?.school_code ||
                            index
                          }
                          value={
                            school?.school_code
                          }
                        >
                          {school?.school_name}
                        </option>
                      )
                    )}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Tingkatan
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_grade_level_id"
                  value={
                    form2.ysb_grade_level_id
                  }
                  onChange={handleChange}
                  disabled={
                    loadingLevel ||
                    !form2.ysb_school_id
                  }
                >
                  <option value="" disabled>
                    {!form2.ysb_school_id
                      ? "Pilih Sekolah terlebih dahulu"
                      : loadingLevel
                      ? "Memuat data tingkatan..."
                      : "Pilih Tingkatan"}
                  </option>

                  {!loadingLevel &&
                    getDataLevel.map(
                      (level, index) => (
                        <option
                          key={
                            level?.id || index
                          }
                          value={level?.id}
                        >
                          {level?.name_level}
                        </option>
                      )
                    )}
                </select>
              </div>

              <div className="sims-filter-field">
                <label className="sims-filter-label">
                  Kelas
                </label>

                <select
                  className="sims-filter-select"
                  name="ysb_kelas_id"
                  value={form2.ysb_kelas_id}
                  onChange={handleChange}
                  disabled={
                    loadingKelas ||
                    !form2.ysb_grade_level_id
                  }
                >
                  <option value="" disabled>
                    {!form2.ysb_grade_level_id
                      ? "Pilih Tingkatan terlebih dahulu"
                      : loadingKelas
                      ? "Memuat data kelas..."
                      : "Pilih Kelas"}
                  </option>

                  {!loadingKelas &&
                    getDataKelas.map(
                      (kelas, index) => (
                        <option
                          key={
                            kelas?.id || index
                          }
                          value={kelas?.id}
                        >
                          {kelas?.name_kelas}
                        </option>
                      )
                    )}
                </select>
              </div>

              <div className="sims-filter-action">
                <button
                  type="button"
                  className="sims-filter-button"
                  onClick={handleCari}
                  disabled={!isFilterComplete}
                >
                  Tampilkan Data
                </button>
              </div>
            </div>
          )}

          {isFetching && (
            <div className="sims-loading">
              <PulseLoader
                color="#3f5bea"
                size={12}
              />
            </div>
          )}

          {hasSearched && !isFetching && (
            <div className="sims-table-card">
              <div className="leger-table-header">
                <h5 className="leger-table-title">
                  Leger - Semester{" "}
                  {namaSmstr || "-"}
                </h5>

                <div className="leger-semester-tabs">
                  {semestersInSelectedYear.map(
                    (semester, index) => (
                      <button
                        type="button"
                        key={
                          semester?.id || index
                        }
                        className={`leger-semester-tab ${
                          String(
                            form2.ysb_semester_id
                          ) ===
                          String(semester?.id)
                            ? "active"
                            : ""
                        }`}
                        onClick={() =>
                          handleSemesterChange(
                            semester
                          )
                        }
                      >
                        Semester{" "}
                        {semester?.semester}
                      </button>
                    )
                  )}
                </div>
              </div>

              <div className="leger-type-tabs-wrapper">
                <div className="leger-type-tabs">
                  {loadingTypeLeger ? (
                    <div className="leger-type-tab-state">
                      Memuat tipe leger...
                    </div>
                  ) : getDataTypeLeger.length >
                    0 ? (
                    getDataTypeLeger.map(
                      (typeLeger, index) => (
                        <button
                          type="button"
                          key={
                            typeLeger?.id ||
                            index
                          }
                          className={`leger-type-tab ${
                            String(
                              selectedTypeLeger
                            ) ===
                            String(
                              typeLeger?.id
                            )
                              ? "active"
                              : ""
                          }`}
                          onClick={() =>
                            setSelectedTypeLeger(
                              typeLeger?.id || ""
                            )
                          }
                        >
                          {typeLeger?.name_type ||
                            "-"}
                        </button>
                      )
                    )
                  ) : (
                    <div className="leger-type-tab-state">
                      Tipe leger belum tersedia
                    </div>
                  )}
                </div>
              </div>

              {isFinalValueTab ? (
                <>
                <div className="leger-final-content">
                  <div className="leger-final-toolbar">
                    <input
                      type="search"
                      className="leger-final-search"
                      placeholder="Cari Nama Siswa"
                      value={searchFinalValue}
                      onChange={(event) =>
                        setSearchFinalValue(
                          event.target.value
                        )
                      }
                    />

                    <button
                      type="button"
                      className="leger-final-download"
                      onClick={handleDownloadFinalValue}
                      disabled={
                        loadingFinalValue ||
                        filteredFinalValueStudents.length === 0
                      }
                    >
                      Unduh Nilai Akhir
                    </button>
                  </div>

                  
                </div>
                  {loadingFinalValue ? (
                    <div className="sims-loading">
                      <PulseLoader
                        color="#3f5bea"
                        size={12}
                      />
                    </div>
                  ) : (
                    <div className="leger-final-table-wrap">
                      <table className="leger-final-table">
                        <thead>
                          <tr>
                            <th className="text-center">No</th>
                            {finalValueHeaders.map(
                              (header, index) => (
                                <th
                                  key={
                                    header?.matpel_id ||
                                    `${header?.title}-${index}`
                                  }
                                >
                                  <span className="leger-final-header-title">
                                    {header?.title || "-"}
                                  </span>

                                  {header?.matpel_id && (
                                    <span className="leger-final-header-subtitle">
                                      Nilai Rapor
                                    </span>
                                  )}
                                </th>
                              )
                            )}
                          </tr>
                        </thead>

                        <tbody>
                          {filteredFinalValueStudents.length > 0 ? (
                            filteredFinalValueStudents.map(
                              (student, studentIndex) => (
                                <tr
                                  key={
                                    student?.ysb_student_id ||
                                    studentIndex
                                  }
                                >
                                  <td>
                                    <span  className="leger-final-number">
                                      {studentIndex + 1}
                                    </span>
                                  </td>
                                  {finalValueHeaders.map(
                                    (header, headerIndex) => (
                                      <td
                                        key={
                                          header?.matpel_id ||
                                          `${header?.title}-${headerIndex}`
                                        }
                                        
                                      >
                                        {getStudentScore(
                                          student,
                                          header
                                        )}
                                      </td>
                                    )
                                  )}
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td
                                className="leger-final-empty"
                                colSpan={Math.max(
                                  finalValueHeaders.length + 1,
                                  1
                                )}
                              >
                                {searchFinalValue
                                  ? "Nama siswa tidak ditemukan"
                                  : "Nilai akhir semester belum tersedia"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              ) : isSpecialValueTab ? (
                <>
                  <div className="leger-final-content leger-special-content">
                    <div className="leger-special-filter-row">
                      <div className="leger-special-field">
                        {/* <label>Mata Pelajaran</label> */}
                        <select
                          className="leger-raw-subject"
                          value={selectedSpecialMatpel}
                          onChange={async (event) => {
                            const matpelId = event.target.value;
                            setSelectedSpecialMatpel(matpelId);
                            setSelectedTypeActivity("");
                            setTypeActivities([]);
                            setSubActivities([]);
                            setSpecialValueHeaders([]);
                            setSpecialValueStudents([]);
                            setSearchSpecialValue("");

                            const activityId = await fetchTypeActivities(matpelId);
                            await fetchSubActivities(activityId);
                            if (activityId) {
                              await fetchSpecialValue(matpelId, activityId);
                            }
                          }}
                          disabled={loadingSpecialMatpel || specialMatpels.length === 0}
                        >
                          <option value="" disabled>
                            {loadingSpecialMatpel
                              ? "Memuat mata pelajaran..."
                              : "Pilih Mata Pelajaran"}
                          </option>
                          {specialMatpels.map((matpel, index) => (
                            <option
                              key={matpel?.ysb_matpel_id || matpel?.id || index}
                              value={matpel?.ysb_matpel_id || matpel?.id || ""}
                            >
                              {matpel?.name_matpel || "-"}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="leger-special-field">
                        {/* <label>Jenis Aktivitas/Kegiatan</label> */}
                        <select
                          className="leger-raw-subject"
                          value={selectedTypeActivity}
                          onChange={async (event) => {
                            const activityId = event.target.value;
                            setSelectedTypeActivity(activityId);
                            setSubActivities([]);
                            setSpecialValueHeaders([]);
                            setSpecialValueStudents([]);
                            setSearchSpecialValue("");

                            await fetchSubActivities(activityId);
                            if (activityId) {
                              await fetchSpecialValue(
                                selectedSpecialMatpel,
                                activityId
                              );
                            }
                          }}
                          disabled={
                            loadingTypeActivities ||
                            !selectedSpecialMatpel ||
                            typeActivities.length === 0
                          }
                        >
                          <option value="" disabled>
                            {loadingTypeActivities
                              ? "Memuat jenis kegiatan..."
                              : "Pilih Jenis Aktivitas/Kegiatan"}
                          </option>
                          {typeActivities.map((activity, index) => (
                            <option
                              key={getTypeActivityId(activity) || index}
                              value={getTypeActivityId(activity)}
                            >
                              {activity?.name_activities || "-"}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="leger-final-toolbar">
                    <input
                      type="search"
                      className="leger-final-search"
                      placeholder="Cari Nama Siswa"
                      value={searchFinalValue}
                      onChange={(event) =>
                        setSearchFinalValue(
                          event.target.value
                        )
                      }
                    />

                    <button
                      type="button"
                      className="leger-final-download"
                      onClick={handleDownloadSpecialValue}
                      disabled={
                        loadingSpecialValue ||
                        filteredSpecialValueStudents.length === 0
                      }
                    >
                    Unduh Nilai Khusus
                    </button>

                   
                  </div>
                  </div>

                  {loadingSpecialValue ||
                  loadingSpecialMatpel ||
                  loadingTypeActivities ||
                  loadingSubActivities ? (
                    <div className="sims-loading">
                      <PulseLoader color="#3f5bea" size={12} />
                    </div>
                  ) : (
                    <div
                      key={`special-table-${selectedSpecialMatpel}-${selectedTypeActivity}`}
                      className="leger-final-table-wrap leger-raw-table-wrap leger-special-table-wrap"
                    >
                      <table
                        className={`leger-final-table leger-raw-table leger-special-table ${
                          specialLeafHeaders.length <= 5 ? "leger-raw-table-full" : ""
                        }`}
                      >
                        <thead>
                          <tr>
                            <th rowSpan={3} className="text-center">No</th>
                            {specialHeaderGroups.map(
                              ({ header, activities, leafCount }, index) => (
                                <th
                                  key={header?.exam_id || `${header?.title || "header"}-${index}`}
                                  colSpan={leafCount}
                                  rowSpan={activities.length ? 1 : 3}
                                  style={{ textAlign: "center" }}
                                >
                                  <span className="leger-final-header-title text-center">
                                    {header?.title || "-"}
                                  </span>
                                </th>
                              )
                            )}
                          </tr>
                          <tr>
                            {specialHeaderGroups.flatMap(
                              ({ header, activities }, headerIndex) =>
                                activities.map((activity, activityIndex) => (
                                  <th
                                    className="leger-raw-subheader"
                                    key={
                                      activity?.id ||
                                      `activity-${header?.exam_id || headerIndex}-${activityIndex}`
                                    }
                                    colSpan={activity.leafCount}
                                    rowSpan={
                                      activity.subActivities.length ? 1 : 2
                                    }
                                  >
                                    <span className="leger-final-header-title">
                                      {activity?.name_activities || "-"}
                                    </span>
                                  </th>
                                ))
                            )}
                          </tr>
                          <tr>
                            {specialHeaderGroups.flatMap(
                              ({ activities }, headerIndex) =>
                                activities.flatMap((activity, activityIndex) =>
                                  activity.subActivities.map(
                                    (subActivity, subActivityIndex) => (
                                  <th
                                    className="leger-raw-subheader"
                                    key={
                                      subActivity?.id ||
                                      `${headerIndex}-${activityIndex}-${subActivityIndex}`
                                    }
                                  >
                                    <span className="leger-final-header-title">
                                      {subActivity?.name_sub_activities || "-"}
                                    </span>
                                  </th>
                                    )
                                  )
                                )
                              )
                            }
                          </tr>
                        </thead>
                        <tbody>
                          {filteredSpecialValueStudents.length > 0 ? (
                            filteredSpecialValueStudents.map((student, studentIndex) => (
                              <tr key={student?.ysb_student_id || studentIndex}>
                                <td>
                                  <span className="leger-final-number">
                                    {studentIndex + 1}
                                  </span>
                                </td>
                                {specialLeafHeaders.map((header, headerIndex) => (
                                  <td
                                    key={
                                      header?.id ||
                                      `${header?.parentTitle || "header"}-${headerIndex}`
                                    }
                                  >
                                    {getSpecialStudentValue(student, header)}
                                  </td>
                                ))}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                className="leger-final-empty"
                                colSpan={Math.max(specialLeafHeaders.length + 1, 1)}
                              >
                                {searchSpecialValue
                                  ? "Nama siswa tidak ditemukan"
                                  : !selectedSpecialMatpel
                                  ? "Mata pelajaran kokurikuler belum tersedia"
                                  : !selectedTypeActivity
                                  ? "Jenis aktivitas/kegiatan belum tersedia"
                                  : subActivities.length === 0
                                  ? "Aspek kegiatan belum tersedia"
                                  : "Nilai khusus belum tersedia"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              ) : isRawValueTab ? (
                <>
                  <div className="leger-final-content">
                    <div className="leger-final-toolbar">
                      <select
                        className="leger-raw-subject"
                        value={selectedMatpel}
                        onChange={(event) => {
                          const matpelId = event.target.value;

                          setSelectedMatpel(matpelId);
                          setSearchRawValue("");
                          setRawValueHeaders([]);
                          setRawValueStudents([]);
                          setRawValueWeights({});
                          fetchRawValue(matpelId);
                        }}
                        disabled={loadingMatpel || getDataMatpel.length === 0}
                      >
                        <option value="" disabled>
                          {loadingMatpel ? "Memuat mata pelajaran..." : "Pilih Mata Pelajaran"}
                        </option>
                        {getDataMatpel.map((matpel, index) => (
                          <option
                            key={matpel?.ysb_matpel_id || matpel?.id || index}
                            value={matpel?.ysb_matpel_id || matpel?.id || ""}
                          >
                            {matpel?.name_matpel || "-"}
                          </option>
                        ))}
                      </select>

                      <input
                        type="search"
                        className="leger-final-search"
                        placeholder="Cari Nama Siswa"
                        value={searchRawValue}
                        onChange={(event) => setSearchRawValue(event.target.value)}
                      />

                      <button
                        type="button"
                        className="leger-final-download"
                        onClick={handleDownloadRawValue}
                        disabled={
                          loadingRawValue ||
                          loadingMatpel ||
                          downloadingRawValue ||
                          getDataMatpel.length === 0
                        }
                      >
                        {downloadingRawValue
                          ? "Menyiapkan Excel..."
                          : "Unduh Semua Nilai Mentah"}
                      </button>
                    </div>
                  </div>

                  {loadingRawValue || loadingMatpel ? (
                    <div className="sims-loading">
                      <PulseLoader color="#3f5bea" size={12} />
                    </div>
                  ) : (
                    <div className="leger-final-table-wrap leger-raw-table-wrap">
                      <table
                        className={`leger-final-table leger-raw-table ${
                          rawLeafHeaders.length <= 5 ? "leger-raw-table-full" : ""
                        }`}
                      >
                        <thead>
                          <tr>
                            <th rowSpan={2} className="text-center">No</th>
                            {rawValueHeaders.map((header, index) => {
                              const children = Array.isArray(header?.ysb_matpel_tp)
                                ? header.ysb_matpel_tp
                                : [];
                              const weightInfo = getRawHeaderWeightInfo(header?.title);
                              return (
                                <th
                                  key={`${header?.title || "header"}-${index}`}
                                  colSpan={Math.max(children.length, Number(header?.colspan) || 1)}
                                  rowSpan={children.length ? 1 : 2}
                                  className={weightInfo ? "leger-raw-summary-header" : ""}
                                  style={{textAlign: "center"}}
                                >
                                  <span className="leger-raw-header-label">
                                    <span className="leger-final-header-title text-center">
                                      {header?.title || "-"}
                                    </span>
                                    {weightInfo && (
                                      <button
                                        type="button"
                                        className="leger-raw-weight-info"
                                        data-tooltip={weightInfo}
                                        aria-label={`Lihat bobot ${header?.title || "header"}`}
                                      >
                                        !
                                      </button>
                                    )}
                                  </span>
                                </th>
                              );
                            })}
                          </tr>
                          <tr>
                            {rawValueHeaders.flatMap((header, headerIndex) =>
                              (Array.isArray(header?.ysb_matpel_tp) ? header.ysb_matpel_tp : []).map(
                                (tp, tpIndex) => (
                                  <th
                                    className="leger-raw-subheader "
                                    key={tp?.id || `${headerIndex}-${tpIndex}`} 
                                  >
                                    <span className="leger-final-header-title">
                                      {tp?.name_tp || "-"}
                                    </span>
                                  </th>
                                )
                              )
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {filteredRawValueStudents.length > 0 ? (
                            filteredRawValueStudents.map((student, studentIndex) => (
                              <tr key={student?.ysb_student_id || studentIndex}>
                                <td>
                                  <span className="leger-final-number">{studentIndex + 1}</span>
                                </td>
                                {rawLeafHeaders.map((header, headerIndex) => (
                                  <td key={header?.id || `${header?.parentTitle}-${headerIndex}`}>
                                    {getRawStudentValue(student, header)}
                                  </td>
                                ))}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                className="leger-final-empty"
                                colSpan={Math.max(rawLeafHeaders.length + 1, 1)}
                              >
                                {searchRawValue
                                  ? "Nama siswa tidak ditemukan"
                                  : selectedMatpel
                                  ? "Nilai mentah belum tersedia"
                                  : "Mata pelajaran belum tersedia"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              ) : (
                <div className="leger-empty-content">
                  Leger belum tersedia
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
